import { Button } from 'ui/button';
import { BUTTON_SIZES } from 'ui/button/constants';
import { MODAL_SIZES, MODAL_VARIANTS, Modal, ModalBody, ModalFooter, ModalHeader } from 'ui/modal';
import noop, { NoOp } from 'utils/noop';
import { ModalType, useModalContext } from '../../context';
import { ScheduleEligibilityFormState } from '../../types';
import { ConfirmDisplayEligibilityCampaignContent } from './ConfirmDisplayEligibilityCampaignContent';

export const CONFIRM_DISPLAY_ELIGIBILITY_CAMPAIGN_MODAL_TEST_ID =
  'confirm-display-eligibility-campaign-modal';
export const CONFIRM_DISPLAY_ELIGIBILITY_CAMPAIGN_MODAL_CONFIRM_BUTTON_TEST_ID =
  'confirm-eligibility-campaign-button';

export type ConfirmScheduleCampaignModalProps = {
  values?: ScheduleEligibilityFormState;
  onConfirm?: NoOp;
};

export const ConfirmDisplayEligibilityCampaignModal = ({
  onConfirm = noop,
  values,
}: ConfirmScheduleCampaignModalProps) => {
  const { closeModal } = useModalContext();
  const { startDate } = values ?? {};

  return (
    <Modal
      data-test={CONFIRM_DISPLAY_ELIGIBILITY_CAMPAIGN_MODAL_TEST_ID}
      id={CONFIRM_DISPLAY_ELIGIBILITY_CAMPAIGN_MODAL_TEST_ID}
      isModalOpen
      onClose={() => closeModal(ModalType.ConfirmDisplayEligibilityCampaign)}
      withPortal
      size={MODAL_SIZES.SMALL}
      variant={MODAL_VARIANTS.DEFAULT}
    >
      <ModalHeader autoFocus={false}>
        {startDate ? 'Confirm schedule' : 'Confirm starting now'}
      </ModalHeader>
      <ModalBody>
        <ConfirmDisplayEligibilityCampaignContent values={values} />
      </ModalBody>
      <ModalFooter cancelLabel="Cancel">
        <Button
          onClick={onConfirm}
          size={BUTTON_SIZES.LARGE}
          data-test={CONFIRM_DISPLAY_ELIGIBILITY_CAMPAIGN_MODAL_CONFIRM_BUTTON_TEST_ID}
        >
          Confirm
        </Button>
      </ModalFooter>
    </Modal>
  );
};
